import { USD_FORMAT_OPTIONS, ETH_FORMAT_OPTIONS, PERCENTAGE_FORMAT_OPTIONS, MILLION, BILLION } from './constants';

/**
 * Format a number as USD
 * @param {number} value - The value to format
 * @returns {string} Formatted USD string
 */
export const formatUSD = (value) => {
    if (!value && value !== 0) return '$0.00';
    
    // Handle small numbers (less than 1 cent)
    if (value > 0 && value < 0.01) {
      return `$${value.toFixed(6)}`;
    }
    
    // Regular formatting for larger numbers
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

/**
 * Format a number as ETH
 * @param {number} value - The value to format
 * @returns {string} Formatted ETH string
 */
export const formatETH = (value) => {
    if (!value && value !== 0) return '0 ETH';
    return `${Number(value).toFixed(3)} ETH`;
  };
/**
 * Format a number as a percentage
 * @param {number} value - The value to format (0-1)
 * @returns {string} Formatted percentage string
 */
export const formatPercentage = (value) => {
    if (!value && value !== 0) return '0%';
    return `${(value * 100).toFixed(1)}%`;
  };
  
  /**
   * Format a number as tokens with appropriate suffix
   * @param {number} value - The token amount
   * @returns {string} Formatted token amount
   */
  export const formatTokenAmount = (value) => {
    if (!value && value !== 0) return '0';
    
    // Format in millions if over 1M
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(2)}M`;
    }
    
    // Format in thousands if over 1K
    if (value >= 1000) {
      return `${(value / 1000).toFixed(2)}K`;
    }
    
    return value.toFixed(2);
  };
  
  /**
   * Format a timestamp as a date
   * @param {number} timestamp - Unix timestamp in seconds
   * @returns {string} Formatted date string
   */
  export const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  };
  
  /**
   * Truncate an Ethereum address
   * @param {string} address - The Ethereum address
   * @returns {string} Truncated address
   */
  export const truncateAddress = (address) => {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };
  
  /**
   * Create a transaction explorer URL
   * @param {string} txHash - Transaction hash
   * @returns {string} Block explorer URL
   */
  export const getTransactionUrl = (txHash) => {
    return `https://basescan.org/tx/${txHash}`;
  };
  
  /**
   * Create an address explorer URL
   * @param {string} address - Ethereum address
   * @returns {string} Block explorer URL
   */
  export const getAddressUrl = (address) => {
    return `https://basescan.org/address/${address}`;
  };